import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

//styles
import './style.scss';

//antd component
import { Button } from 'antd';

//assets
import CustomIcons from 'components/CustomIcons';

function FinalScreen({ continueAction, title, loading, successful, content, children, className }) {
  const childClassName = classNames('absence-final-screen', className);
  const { t } = useTranslation();

  return (
    <div className={childClassName}>
      <div className="absence-final-screen__icon">
        <CustomIcons type="sick-leave" />
      </div>
      <div className="absence-final-screen__content">
        <h3 className="content-title">
          {!!title && title || t("screens.finalScreenTitle")}
        </h3>
        
        {(content || children) && (
          <div
            className="content-text"
            dangerouslySetInnerHTML={{
              __html: !!(content || children) && (content || children) || t("screens.finalScreenContent")
            }}
          />
        )}
      </div>
    
      {!!continueAction && (
        <Button loading={loading} disabled={loading} onClick={continueAction} className="absence-final-screen__btn">
          {t("common.continue")}
        </Button>
      )}
    </div>
  );
}

FinalScreen.defaultProps = {};

FinalScreen.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  continueAction: PropTypes.func,
};

export default memo(FinalScreen);
